/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/.editorconfig" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: ".editorconfig",
      ext: "",
      content:
        "# http://editorconfig.org\nroot = true\n\n[*]\nindent_style = space\nindent_size = 2\nend_of_line = lf\ncharset = utf-8\ntrim_trailing_whitespace = true\ninsert_final_newline = true\n\n[*.md]\ntrim_trailing_whitespace = false\n\n[Makefile]\nindent_style = tab\n",
    },
  ];
}
